"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CambridgeAssessmentEnglishLogo", {
  enumerable: true,
  get: function get() {
    return _CambridgeAssessmentEnglishLogo.default;
  }
});
Object.defineProperty(exports, "CambridgeAssessmentLogo", {
  enumerable: true,
  get: function get() {
    return _CambridgeAssessmentLogo.default;
  }
});
Object.defineProperty(exports, "CambridgeInternationalLogo", {
  enumerable: true,
  get: function get() {
    return _CambridgeInternationalLogo.default;
  }
});
Object.defineProperty(exports, "CambridgeUniversityPressAndAssessment", {
  enumerable: true,
  get: function get() {
    return _CambridgeUniversityPressAndAssessment.default;
  }
});
Object.defineProperty(exports, "CambridgeUniversityPressLogo", {
  enumerable: true,
  get: function get() {
    return _CambridgeUniversityPressLogo.default;
  }
});
Object.defineProperty(exports, "OCRLogo", {
  enumerable: true,
  get: function get() {
    return _OCRLogo.default;
  }
});

var _CambridgeAssessmentLogo = _interopRequireDefault(require("./CambridgeAssessmentLogo"));

var _CambridgeAssessmentEnglishLogo = _interopRequireDefault(require("./CambridgeAssessmentEnglishLogo"));

var _CambridgeInternationalLogo = _interopRequireDefault(require("./CambridgeInternationalLogo"));

var _CambridgeUniversityPressLogo = _interopRequireDefault(require("./CambridgeUniversityPressLogo"));

var _CambridgeUniversityPressAndAssessment = _interopRequireDefault(require("./CambridgeUniversityPressAndAssessment"));

var _OCRLogo = _interopRequireDefault(require("./OCRLogo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3VuZGF0aW9uYWwvTG9nb3MvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBDYW1icmlkZ2VBc3Nlc3NtZW50TG9nbyB9IGZyb20gJy4vQ2FtYnJpZGdlQXNzZXNzbWVudExvZ28nO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBDYW1icmlkZ2VBc3Nlc3NtZW50RW5nbGlzaExvZ28gfSBmcm9tICcuL0NhbWJyaWRnZUFzc2Vzc21lbnRFbmdsaXNoTG9nbyc7XG5leHBvcnQgeyBkZWZhdWx0IGFzIENhbWJyaWRnZUludGVybmF0aW9uYWxMb2dvIH0gZnJvbSAnLi9DYW1icmlkZ2VJbnRlcm5hdGlvbmFsTG9nbyc7XG5leHBvcnQgeyBkZWZhdWx0IGFzIENhbWJyaWRnZVVuaXZlcnNpdHlQcmVzc0xvZ28gfSBmcm9tICcuL0NhbWJyaWRnZVVuaXZlcnNpdHlQcmVzc0xvZ28nO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBDYW1icmlkZ2VVbml2ZXJzaXR5UHJlc3NBbmRBc3Nlc3NtZW50IH0gZnJvbSAnLi9DYW1icmlkZ2VVbml2ZXJzaXR5UHJlc3NBbmRBc3Nlc3NtZW50JztcbmV4cG9ydCB7IGRlZmF1bHQgYXMgT0NSTG9nbyB9IGZyb20gJy4vT0NSTG9nbyc7XG4iXX0=